/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PostLiffVideoCompleteMultiPartUploadRequestPartsInner } from './PostLiffVideoCompleteMultiPartUploadRequestPartsInner';
import {
    PostLiffVideoCompleteMultiPartUploadRequestPartsInnerFromJSON,
    PostLiffVideoCompleteMultiPartUploadRequestPartsInnerFromJSONTyped,
    PostLiffVideoCompleteMultiPartUploadRequestPartsInnerToJSON,
} from './PostLiffVideoCompleteMultiPartUploadRequestPartsInner';

/**
 * 
 * @export
 * @interface PostLiffVideoCompleteMultiPartUploadRequest
 */
export interface PostLiffVideoCompleteMultiPartUploadRequest {
    /**
     * 
     * @type {string}
     * @memberof PostLiffVideoCompleteMultiPartUploadRequest
     */
    uploadId: string;
    /**
     * 
     * @type {string}
     * @memberof PostLiffVideoCompleteMultiPartUploadRequest
     */
    fileName: string;
    /**
     * 
     * @type {Array<PostLiffVideoCompleteMultiPartUploadRequestPartsInner>}
     * @memberof PostLiffVideoCompleteMultiPartUploadRequest
     */
    parts: Array<PostLiffVideoCompleteMultiPartUploadRequestPartsInner>;
}

/**
 * Check if a given object implements the PostLiffVideoCompleteMultiPartUploadRequest interface.
 */
export function instanceOfPostLiffVideoCompleteMultiPartUploadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uploadId" in value;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "parts" in value;

    return isInstance;
}

export function PostLiffVideoCompleteMultiPartUploadRequestFromJSON(json: any): PostLiffVideoCompleteMultiPartUploadRequest {
    return PostLiffVideoCompleteMultiPartUploadRequestFromJSONTyped(json, false);
}

export function PostLiffVideoCompleteMultiPartUploadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffVideoCompleteMultiPartUploadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uploadId': json['uploadId'],
        'fileName': json['fileName'],
        'parts': ((json['parts'] as Array<any>).map(PostLiffVideoCompleteMultiPartUploadRequestPartsInnerFromJSON)),
    };
}

export function PostLiffVideoCompleteMultiPartUploadRequestToJSON(value?: PostLiffVideoCompleteMultiPartUploadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uploadId': value.uploadId,
        'fileName': value.fileName,
        'parts': ((value.parts as Array<any>).map(PostLiffVideoCompleteMultiPartUploadRequestPartsInnerToJSON)),
    };
}

